{
  "title": "仪表板",
  "greeting": "早上好，{{name}}",
  "greetingAnonymous": "早上好",
  "scope": {
    "onlyMine": "仅我的",
    "workspaceTrigger": "切换工作区",
    "teamTrigger": "切换团队",
    "allWorkspaces": "所有工作区",
    "allTeams": "所有团队",
    "searchPlaceholder": "搜索…",
    "pickerEmpty": "未找到"
  },
  "summary": {
    "mine": "{{attention}} 项需要你处理 · 未来 {{days}} 天内有 {{shoots}} 场你的拍摄",
    "workspace": "{{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄",
    "organization": "组织内有 {{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄",
    "team": "该团队有 {{attention}} 项需要关注 · 未来 {{days}} 天内有 {{shoots}} 场拍摄",
    "total": "待处理事项"
  },
  "sections": {
    "attention": "需要关注",
    "attentionHint": "最紧急的排在最前；处理完成后该行会消失",
    "timeline": "未来 {{days}} 天",
    "timelineHint": "按泳道排列的拍摄日期；指向色条查看团队与状态",
    "workspaces": "工作区",
    "workspacesHint": "当前工作量与风险所在",
    "summaryHint": "点击类别在对应标签打开队列",
    "later": "时段内稍后",
    "laterHint": "明天之后的拍摄"
  },
  "shoot": {
    "open": "打开制作",
    "untitled": "未命名制作",
    "crewMeter": "已预订团队",
    "callsheetMeter": "通告单",
    "callsheet_shared": "已发送",
    "callsheet_building": "编写中",
    "callsheet_missing": "尚未开始",
    "crewOpen": "仍空缺",
    "crewBooked": "已预订",
    "crewUnnamedRole": "未命名角色",
    "crewMore": "另有 {{count}} 人"
  },
  "status": {
    "active": "拍摄中",
    "ready": "已就绪",
    "resourcing": "招募中",
    "alert": "有风险",
    "draft": "尚无角色",
    "complete": "已完成"
  },
  "when": {
    "today": "今天",
    "tomorrow": "明天",
    "inDays_other": "{{count}} 天后"
  },
  "stats": {
    "shoots": "拍摄",
    "shootsHint": "未来 {{days}} 天内",
    "rolesFilled": "已预订角色",
    "rolesFilledHint": "{{total}} 个角色中的 {{booked}} 个",
    "pencils": "待确认的暫定预订",
    "pencilsHint": "未来 {{days}} 天内的预留",
    "attention": "需要关注",
    "attentionHint": "项等待处理",
    "availability": "档期询问",
    "availabilityHint": "已发出，尚未回复"
  },
  "filters": {
    "all": "全部",
    "resourcing": "招募",
    "availability": "档期",
    "callsheets": "通告单",
    "bookings": "预订"
  },
  "attention": {
    "ariaLabel": "需要关注的事项",
    "empty": "这里没有待处理的事项。",
    "rolesUnfilled": {
      "title_other": "{{production}} 有 {{count}} 个角色尚未确定",
      "description": "拍摄开始于 {{date}}",
      "action": "寻找团队"
    },
    "callsheetMissing": {
      "title": "{{production}} 还没有通告单",
      "description_other": "已预订 {{count}} 位团队成员",
      "action": "打开"
    },
    "callsheetBuilding": {
      "title": "{{production}} 的通告单尚未发送",
      "description": "收件人还没有集合信息",
      "action": "打开"
    },
    "availability": {
      "title": "{{resource}} 尚未回复",
      "someone": "该资源",
      "description": "询问的档期：{{range}}",
      "due_other": "已等待 {{count}} 天",
      "dueToday": "今天发出",
      "action": "打开资源"
    },
    "pencils": {
      "title_other": "{{count}} 个暫定预订需要确认",
      "description": "未来 {{days}} 天内的预留",
      "due": "本时段",
      "action": "打开预订"
    }
  },
  "timeline": {
    "empty": "该时段内没有拍摄。",
    "unassigned": "未分配团队",
    "crew": "已预订团队 {{booked}} / {{total}}",
    "demandBooked_other": "已预订 {{count}} 人",
    "demandUnfilled_other": "{{count}} 个岗位尚未确定",
    "legend": {
      "active": "拍摄中",
      "ready": "已就绪",
      "resourcing": "招募中",
      "alert": "有风险"
    },
    "openRoles": "{{count}} 个空缺"
  },
  "workspaces": {
    "shoots_other": "未来 {{days}} 天内有 {{count}} 场拍摄",
    "rolesFilled": "已预订角色",
    "attention": "{{value}} 项待处理",
    "noAttention": "一切顺利",
    "open": "打开",
    "emptyTitle": "还没有工作区",
    "empty": "该组织还没有工作区。"
  },
  "loadError": "无法加载仪表板。",
  "demo": {
    "toggle": "查看仪表板的潜力",
    "bannerTitle": "您正在查看示例数据",
    "bannerMessage": "这是虚构的忙碌两周，展示当您的拍摄、团队和通告单都在 Atellio 中时仪表板的样子。链接已停用。",
    "exit": "返回我的数据"
  },
  "view": {
    "trigger": "视图：{{view}}",
    "menuLabel": "仪表板视图",
    "names": {
      "today": "今日",
      "plan": "计划",
      "table": "表格",
      "overview": "概览"
    },
    "descriptions": {
      "today": "先看需要你处理的事，再看即将拍摄",
      "plan": "整个时段内谁在何时拍摄，以及每天的人员",
      "table": "时段内所有拍摄的一张列表",
      "overview": "一眼看到关键数字和即将拍摄"
    },
    "answers": {
      "today": "我负责安排人员并跟进确认",
      "plan": "我规划谁在何时工作",
      "table": "我同时管理很多制作",
      "overview": "我查看一切是否按计划进行"
    },
    "question": "你在 Atellio 中最常做什么？",
    "questionHint": "我们会据此安排仪表板，你可以随时切换。",
    "skip": "跳过",
    "pickedHint": "当前为「{{view}}」视图。可随时在右上角的“视图”中更改。",
    "pickedHintDismiss": "知道了"
  },
  "table": {
    "title": "未来 {{days}} 天的拍摄",
    "hint": "按时间先后排列；点击名称打开制作",
    "production": "制作",
    "lane": "团队",
    "laneWorkspace": "工作区",
    "dates": "日期",
    "status": "状态",
    "crew": "人员",
    "callsheet": "通告单",
    "issues": "问题",
    "filterAll": "全部",
    "filterWithIssues": "有问题",
    "filterThisWeek": "本周",
    "issueCount_other": "{{count}} 个问题"
  },
  "day": {
    "hint": "需要 {{count}} 人 · {{unfilled}} 人未定 · 在上方选择其他日期",
    "empty": "当天没有拍摄。"
  },
  "overview": {
    "today": "今天",
    "todayHeadline_other": "{{count}} 场拍摄进行中",
    "todayEmpty": "今天没有拍摄",
    "atRisk": "有风险",
    "ready": "人员已定，没有需要你处理的事。",
    "laterEmpty": "时段内没有其他拍摄。"
  },
  "agenda": {
    "stripLabel": "时段内的日期",
    "stripCaption": "每个圆点代表一场拍摄 · 橙色表示有风险",
    "dayShoots_other": "{{count}} 场拍摄",
    "dayAtRisk": "{{count}} 场有风险",
    "laterOpen_other": "时段内稍后还有 {{count}} 场拍摄，其中 {{open}} 场有待办。",
    "laterReady_other": "时段内稍后还有 {{count}} 场拍摄，全部按计划进行。",
    "seePlan": "查看完整计划",
    "title": "即将开始",
    "onSet": "今日在拍",
    "onSetShoots_other": "{{count}} 场拍摄",
    "onSetPeople_other": "{{count}} 人",
    "onSetReady": "全部就绪",
    "onSetOpen_other": "{{count}} 场仍有待办",
    "noCrew": "尚未安排工作人员",
    "onSetMore_other": "今天还有 {{count}} 场拍摄在进行"
  },
  "create": {
    "production": "新建制作"
  }
}
